"use strict";

var Logger = require("js-logger");
var LoggerInstance = Logger.get("ApiHelper");

// ApiHelper
module.exports = {
	encodeResourceIdForApi: function (value) {
		//Periods need to be encoded for the WebAPI, because when the WebAPI sees a period, it thinks a file is being requested.
		//	%2E is a period, but we are double encoding it, as the WebAPI double decodes
		return encodeURIComponent(encodeURIComponent(value)).replace(/\./g, "%252E");
	},

	getUrlParameter: function (name, url) {
		if (!url) {
			url = window.location.href
		}

		name = name.replace(/[\[\]]/g, "\\$&");

		var regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
		var results = regex.exec(url);

		if (!results) {
			return null;
		}

		if (!results[2]) {
			return "";
		}

		return decodeURIComponent(results[2].replace(/\+/g, " "));
	},

	// Recursivly walk an object's key/value pairs and convert all empty string values to null
	convertEmptyValuesToNull: function (objectToModify) {
		if (!objectToModify || typeof objectToModify !== "object") {
			return;
		}
		Object.keys(objectToModify).forEach(key => {
			if (typeof objectToModify[key] === "object") {
				this.convertEmptyValuesToNull(objectToModify[key]);
			} else {
				if (objectToModify[key] === "") {
					objectToModify[key] = null;
				}
			}
		});
	},

	// Will convert something like {"firstName": "User", "phone": { "type": null } } to {"firstName": "User", "phone": null }
	convertObjectWithAllNullPropertiesToNull: function (objectToModify) {
		if (!objectToModify || typeof objectToModify !== "object") {
			return;
		}
		var areAllPropertiesNull = true;
		//Going through each property on the model
		Object.keys(objectToModify).forEach(key => {
			var value = objectToModify[key];
			if (typeof value === "object" && value) {
				//If we are an object, we are going to recurrsively call ourself
				if (this.convertObjectWithAllNullPropertiesToNull(value) !== null) {
					areAllPropertiesNull = false;
				} else {
					//All of the internal object's properties are null, so set the object to null
					objectToModify[key] = null;
				}
			} else if(value !== null) {
				areAllPropertiesNull = false;
			}
		});

		//If all of our properties are null, go ahead and return null (the caller can decide whether to use the return or not); otherwise, return objectToModify
		return areAllPropertiesNull ? null : objectToModify;
	},

	deleteUndefinedValues: function (obj, includeNulls) {
		//Delete values that are not set
		Object.keys(obj).forEach(key => {
			if (obj[key] === undefined || (includeNulls && obj[key] === null)) {
				delete obj[key];
			}
		});

		return obj;
	},

	displayErrorMessage: function (jqXHR, fallbackMessage) {
		// TODO - US#5036 Enhance error handling for ASO account creation messages.
		LoggerInstance.error(jqXHR);
		if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message) {
			BootstrapPrompt.alert(jqXHR.responseJSON.message);
		} else {
			BootstrapPrompt.alert(fallbackMessage || window.GENERAL_MESSAGES.GENERAL_ERROR_MESSAGE);
		}
	},

	getFileInfo: function (contentDisposition, defaultFileName) {
		// Get the file name from the content disposition response header.
		var captureGroups = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/);
		var fileName = captureGroups && captureGroups.length > 1 && captureGroups[1] || defaultFileName;

		var mimeType = "application/octet-stream";
		var fileExtension = fileName.split(".").pop();
		switch (fileExtension) {
			case "pdf":
				mimeType = "application/pdf";
				break;
			case "txt":
				mimeType = "text/plain";
				break;
			case "csv":
				mimeType = "text/csv";
				break;
			case "xls":
				mimeType = "application/vnd.ms-excel";
				break;
			case "xlsx":
				mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
				break;
			case "doc":
				mimeType = "application/msword";
				break;
			case "docx":
				mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
				break;
			case "ppt":
				mimeType = "application/vnd.ms-powerpoint";
				break;
			case "pptx":
				mimeType = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
				break;
			default:
				break;
		}

		return {
			fileName,
			mimeType
		};
	},

	logErrorAndReturnRejectedDeferred: function (logger, errorMessage, deferred) {
		return this._logAndReturnDeferred(logger, Logger.ERROR, errorMessage, deferred, "reject");
	},

	logErrorAndReturnResolvedDeferred: function(logger, errorMessage, deferred) {
		return this._logAndReturnDeferred(logger, Logger.ERROR, errorMessage, deferred, "resolve");
	},

	logDebugAndReturnResolvedDeferred: function (logger, message, deferred) {
		return this._logAndReturnDeferred(logger, Logger.DEBUG, message, deferred, "resolve");
	},

	_logAndReturnDeferred: function (logger, loggingLevel, message, deferred, returnType) {
		deferred = deferred || new $.Deferred();

		logger.invoke(loggingLevel, message);

		switch (returnType) {
			case "reject":
				deferred.reject(message);
				break;
			case "resolve": {
				deferred.resolve(message);
				break;
			}
		}
		return deferred;
	}
};
